import { useParams } from 'react-router-dom'

export function VerificationDetailPage() {
  const { id } = useParams<{ id: string }>()
  
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Verification Details</h1>
        <p className="text-gray-500 mt-1">ID: {id}</p>
      </div>
      
      <div className="bg-white rounded-xl border border-gray-200 p-8">
        <p className="text-gray-600">Detailed verification view coming soon</p>
      </div>
    </div>
  )
}
